module.exports = __webpack_public_path__ + "static/f597b0de-f3b2-4ee4-b7a4-2fcab70b28be-250.9ab65579.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/plymouth-combined-crown-and-county-courts/f597b0de-f3b2-4ee4-b7a4-2fcab70b28be-250.jpg
// module id = 1043
// module chunks = 168707334958949